import { createInteractiveColorVar } from '../../helpers/createInteractiveColorVar/index.js';

const ControlPlaceholderColors = createInteractiveColorVar('controls-placeholder');
const ControlPlaceholderColorsLightValues = Object.freeze({
    default: '#929292',
    action: '#929292',
    active: '#929292',
    activeAction: '#929292',
});
const ControlPlaceholderColorsDarkValues = Object.freeze({
    default: '#737373',
    action: '#737373',
    active: '#737373',
    activeAction: '#737373',
});

export { ControlPlaceholderColors, ControlPlaceholderColorsDarkValues, ControlPlaceholderColorsLightValues };
